// External libs
import { createAction } from '@reduxjs/toolkit'

const closeAction = createAction('logOutDialog/close')

const clearAction = createAction('logOutDialog/clear')

const maximizeAction = createAction('logOutDialog/maximize')

const openAction = createAction('logOutDialog/open')

const clear = () => (dispatch: any) => {
  dispatch(clearAction())
}

const close = () => (dispatch: any) => {
  dispatch(closeAction())
}

const maximize = () => (dispatch: any) => dispatch(maximizeAction())

const open = () => (dispatch: any) => {
  dispatch(openAction())
}

const actions = {
  clear,
  clearAction,
  close,
  closeAction,
  maximize,
  maximizeAction,
  open,
  openAction,
}

export default actions
